import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


/**
 * Checkbox component inside ag-grid
 *
 * @export
 * @class CheckboxCellComponent
 * @implements {ICellRendererAngularComp}
 */
@Component({
    selector: 'grid-row-checkbox',
    template: `<input type="checkbox" style="width: 20px;height: 20px;vertical-align: middle;" [checked]="params.value" (change)="onChange($event)">`,
    standalone: false
})

export class RowCheckboxComponent implements ICellRendererAngularComp {

	public params: ICellRendererParams;
	fieldName;
	checked: boolean;
	agInit(params: any): void {
		this.params = params;
		this.checked = params.data.rowCheckBox;
		this.fieldName = this.params.colDef.field;
	}

	refresh(params: any): boolean {
		this.params = params;
		return true;
	}


	onChange(event) {
		if (this.fieldName == "rowCheckBox") { // NOSONAR
			this.params.context.componentParent.userCheckChanged(event.currentTarget.checked, this.params.node.rowIndex);
		}
	}

	constructor() { }
}
